/**
 * @file Web Gallery Blog related fragments.
 */

import gql from 'graphql-tag';

export const blogPostViewsCreate = gql`
  mutation blogPostViewsCreate($input: BlogPostViewsCreateInput!) {
    blogPostViewsCreate(input: $input) {
      success
    }
  }
`;
